import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUserIsViewOnly } from 'spw-redux/modules/projects/selectors';
import { selectPositionablePSDialogCounter } from 'spw-redux/modules/program-summary/programming/selectors';
import { INDIVIDUAL_WORKSPACES_CATEGORY } from 'spw-constants';
import WorksheetRow from '../../models/WorksheetRow';

interface Options {
  row: WorksheetRow;
  subject: 'USF' | 'Seats';
}

export const useDisableBulkEditButton = ({ row, subject }: Options) => {
  const viewOnly = useSelector(selectCurrentUserIsViewOnly);
  const positionablePSDialogCounter = useSelector(
    selectPositionablePSDialogCounter
  );

  const disable = useMemo(
    () =>
      viewOnly ||
      Boolean(positionablePSDialogCounter) ||
      row.isStorageSupportSpace ||
      (row.category === INDIVIDUAL_WORKSPACES_CATEGORY && subject === 'Seats'),
    [
      viewOnly,
      positionablePSDialogCounter,
      row.isStorageSupportSpace,
      row.category,
      subject,
    ]
  );

  return disable;
};
